import { render } from "./ResultTableItemSkUni.vue?vue&type=template&id=5b80679c&scoped=true"
import script from "./ResultTableItemSkUni.vue?vue&type=script&lang=js"
export * from "./ResultTableItemSkUni.vue?vue&type=script&lang=js"

import "./ResultTableItemSkUni.vue?vue&type=style&index=0&id=5b80679c&scoped=true&lang=css"
import "./ResultTableItemSkUni.vue?vue&type=style&index=1&id=5b80679c&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\33\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b80679c"]])

export default __exports__